<style scoped>
	.version-content{
		display: none;
	}
	.version-content.active{
		display: block;
	}
	#quote-container{
		padding: 40px;
		border-radius: 0 0 8px 8px;
		overflow-x: auto;
	}
	#quote{
		color: #787878;
		margin: 0 auto;
		min-height: 279mm;
		padding: 60pt 40pt;
		min-width: 215mm;
	}
	#quote b{
		color: #505050;
		font-weight: 500;
	}
	table{
		border-collapse: collapse;
		margin: 20pt 0;
		width: 100%;
	}
	table caption, .title-caption-section{
		padding: 20px;
	}
	table th, table td{
		vertical-align: top;
	}
	/*Estilos para pdf simular al momento de dividir las columnas de los productos*/
	.general_color_style{
		color: #787878;
	}
	.general_color_style b{
		color: #505050;
		font-style: bold;
	}
	.link_styles{
		color: #03C4C4;
		font-style: bold;
		display: inline-block;
		margin-bottom: 1em;
	}
	.productos th, .productos td{
		color: #787878;
		padding: 10px;
	}
	.productos thead{
		background-color: rgb(245,245,245);
	}
	.productos thead th{
		color: #505050;
		font-size: 8pt;
		letter-spacing: 0.1em;
		text-transform: uppercase;
	}
	.productos tbody tr{
		border-bottom: solid 1px rgb(245,245,245);
	}
	.productos p{
		font-size: 8pt;
		margin-top: 0;
	}
	.productos b{
		color: #787878;
	}
	.productos tfoot strong{
		font-size: 8pt;
	}
	.productos small{
		font-size: 8.5pt;
	}
	.referencias{
		border-left: solid 4px #FDDA24;
		font-size: 8pt;
		margin: 20pt 0;
		padding: 5pt 20pt;
	}
	.referencias p{
		margin: 0;
	}
	.notas{
		font-size: 9pt;
	}
	.referencias h4, .notas h4{
		font-size: 9pt;
		color: #505050;
		text-transform: uppercase;
	}
	.referencias h4{
		margin-bottom: 10pt;
	}
	.referencias small{
		font-size: 8pt;
	}
	.notas h4{
		margin: 10pt 0;
	}
	.productos tbody td p, .notas p{
		white-space: pre-line;
		word-wrap: break-word;
	}
	/*Estilos Preview*/
	table.table-beauty tbody tr:nth-child(even){
		background-color: rgb(250,250,250);
	}

	table.table-beauty td, table.table-beauty th{
		padding: 10px 20px;
	}
</style>
<template>
	<div class="screen page quote b-soft">
		<div id="pantalla-espera" v-if="isLoading"></div>
		<div class="grid">
			<div v-if="versiones.length" class="container">
				<ul class="tabs">
					<li v-for="version in versiones" v-bind:key="version.id" v-bind:class="{'active': current_version == version.id}" v-on:click.prevent="viewVersion(version.id)">
						V.{{version.folio}}
					</li>
					<li v-on:click.prevent="goTo('/version/'+$route.params.id)">
						Añadir
					</li>
				</ul>
				<div class="preview_contenedor temporal" id="temporal_contenedor_productos"></div>
				<div class="preview_contenedor temporal" id="temporal_contenedor_nota_propuesta_inversion"></div>
				<div v-for="version in versiones" v-bind:key="version.id" v-bind:id="'version_'+version.id" class="version-content" v-bind:class="{'active': current_version == version.id}">
					<div v-if="version.contenido" class="container">
						<div class="row h-items-center" id="general-quote-container">
							<div class="col-12 box-container b-complementary" id="quote-container">
								<div class="box-container b-white" id="quote">
									<div class="row">
										<div class="col-4 phone-c-4">
											<p class="t-center">
												<a href="#" class="btn b-secondary" v-on:click.prevent="goTo('/version/'+$route.params.id+'/'+version.id)">Editar Versión</a>
											</p>
										</div>
										<div class="col-4 phone-c-4">
											<p class="t-center">
												<a href="#" class="btn b-primary" v-on:click.prevent="makePdf(version, 'version_'+version.id, 'normal')">Descargar PDF</a>
											</p>
											<p class="t-center">
												<a href="#" class="link" v-on:click.prevent="makePdf(version, 'version_'+version.id, 'censurado')">PDF a trabajar</a>
											</p>
										</div>
										<div class="col-4 phone-c-4">
											<p class="t-center">
												<a href="#" class="btn b-warn" v-on:click.prevent="deleteVersion(version.id)">Eliminar Versión</a>
											</p>
										</div>
										<div class="col-12">
											<table class="t-left intro">
												<thead>
													<tr>
														<th></th>
														<th style="text-align: right;"></th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td>
															<p>
																<b>Fecha Cotización:</b><br>{{version.fecha.seconds | simpleFormatDate}}
																<br>
																<b>Folio:</b><br>{{makeNewFolio(version)}}
															</p>
														</td>
														<td style="text-align: right;">
															<p>
																<span v-if="version.fecha_creacion"><b>Fecha Creación: </b><br>{{version.fecha_creacion.seconds | beautyFormatDate}} <span v-if="version.usuario_creador">Por {{version.usuario_creador}}</span></span>
																<br>
																<span v-if="version.fecha_modificacion"><b>Fecha Modificación: </b><br>{{version.fecha_modificacion.seconds | beautyFormatDate}} <span v-if="version.usuario_editor">Por {{version.usuario_editor}}</span></span>
															</p>
														</td>
													</tr>
												</tbody>
											</table>
											<div class="preview_contenedor quote_page">
												<div v-for="(producto, index) in version.contenido" v-bind:key="index" class="quote_page_content">
													<h1 v-if="index == 0">Servicios</h1>
													<div v-if="!producto.salto || producto.salto != true" class="quote_page_product" v-html="'<h2>'+producto.nombre+'</h2>'+producto.contenido+producto.anotaciones"></div>
													<div v-else class="quote_page_product" v-html="'<span class=columnbreak></span>'"></div>
												</div>
											</div>
											<table v-if="version.contenido && !version.propuesta_inversion.elementos" class="t-left table-beauty">
												<caption><h2><b>Propuesta Servicios</b></h2></caption>
												<thead>
													<tr>
														<th>Categoría</th>
														<th>Contenido</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="(producto, index) in version.contenido" v-bind:key="index">
														<td v-if="producto.id_servicio">
															<p>
																{{producto.id_servicio.nombre}}
															</p>
														</td>
														<td v-if="producto.nombre">
															<p>
																{{producto.nombre}}
															</p>
															<span v-if="producto.contenido">{{producto.contenido | clearHtmlTextCut}}</span>
														</td>
													</tr>
												</tbody>
											</table> 
											<table v-if="version.propuesta_inversion && version.propuesta_inversion.elementos" class="t-left table-beauty">
												<caption>
													<h2>
														<b>Propuesta Económica</b>
													</h2>
													<p v-if="version.propuesta_inversion && version.propuesta_inversion.titulo" class="t-center t-18-px">
														<b>{{version.propuesta_inversion && version.propuesta_inversion.titulo}}</b>
													</p>
												</caption>
												<thead>
													<tr>
														<th class="t-14-px"></th>
														<th class="t-14-px">Frecuencia</th>
														<th class="t-right t-14-px">Cantidad</th>
														<th class="t-right t-14-px" style="white-space: nowrap;">Precio Unitario <br>MXP</th>
														<th class="t-right t-14-px" style="white-space: nowrap;">Precio Hora <br>MXP</th>
														<th class="t-right t-14-px" style="white-space: nowrap;">Subtotal <br>MXP</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="(elemento_inversion, index) in version.propuesta_inversion.elementos" v-bind:key="index">
														<td>
															<p v-if="elemento_inversion.nombre">
																{{elemento_inversion.nombre}}
															</p>
														</td>
														<td>
															<p v-if="elemento_inversion.frecuencia">
																{{elemento_inversion.frecuencia}}
															</p>
														</td>
														<td class="t-right">
															<p v-if="elemento_inversion.cantidad">
																{{elemento_inversion.cantidad | formatEntero}}
															</p>
														</td>
														<td class="t-right">
															<p v-if="elemento_inversion.precio">
																{{$options.filters.formatDecimal(elemento_inversion.precio) | formatPrice}}
															</p>
														</td>
														<td class="t-right">
															<p v-if="elemento_inversion.precio_hora">
																{{$options.filters.formatDecimal(elemento_inversion.precio_hora) | formatPrice}}
															</p>
															<p v-else>
																---
															</p>
														</td>
														<td class="t-right">
															<p v-if="elemento_inversion.cantidad && elemento_inversion.precio">
																{{ elemento_inversion.cantidad * $options.filters.formatDecimal(elemento_inversion.precio) | formatPrice}}
															</p>
														</td>
													</tr>
													<tr v-if="version">
														<td></td>
														<td></td>
														<td></td>
														<td></td>
														<td class="t-right">
															<p>
																<strong>TOTAL:</strong>
															</p>
														</td>
														<td class="t-right">
															<p>
																<strong>{{sum_inversion(version) | formatPrice}}</strong>
															</p>
														</td>
													</tr>
												</tbody>
											</table> 
										</div>
										<div class="col-12">
											<div v-if="version.propuesta_inversion && version.propuesta_inversion.nota" class="contenedor_nota_propuesta_inversion" v-html="'<p><strong>Nota: </strong></p>' + version.propuesta_inversion.nota"></div>
										</div>
										<div class="col-4 phone-c-4">
											<p class="t-center">
												<a href="#" class="btn b-secondary" v-on:click.prevent="goTo('/version/'+$route.params.id+'/'+version.id)">Editar Versión</a>
											</p>
										</div>
										<div class="col-4 phone-c-4">
											<p class="t-center">
												<a href="#" class="btn b-primary" v-on:click.prevent="makePdf(version, 'version_'+version.id)">Descargar PDF</a>
											</p>
											<p class="t-center">
												<a href="#" class="link" v-on:click.prevent="makePdf(version, 'version_'+version.id, 'censurado')">PDF a trabajar</a>
											</p>
										</div>
										<div class="col-4 phone-c-4">
											<p class="t-center">
												<a href="#" class="btn b-warn" v-on:click.prevent="deleteVersion(version.id)">Eliminar Versión</a>
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-else class="container">
						<div class="row">
							<div class="col-12 box-container b-complementary t-center" id="quote-container">
								<div class="box-container b-white" id="quote">
									<p>
										No se encontraron los campos requeridos en la cotización, puedes realizar las siguientes acciones: 
									</p>
									<p>
										<a href="#" class="btn b-secondary" v-on:click.prevent="goTo('/version/'+$route.params.id+'/'+version.id)">Puedes editar esta versión</a>
										<a href="#" class="btn b-warn" v-on:click.prevent="deleteVersion(version.id)">Eliminar esta versión</a>
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="container">
				<div class="row">
					<div class="col-12 box-container b-complementary t-center" id="quote-container">
						<div class="box-container b-white" id="quote">
							<p>
								No se encontraron versiones en la cotización, puedes realizar las siguientes acciones: 
							</p>
							<p>
								<a href="#" class="btn b-secondary" v-on:click.prevent="goTo('/version/'+$route.params.id)">Crear Una Versión</a>
							</p>
						</div>
					</div>
				</div>
			</div>
			<GetFooter />
		</div>
	</div>
</template>

<script src="https://cdn.rawgit.com/blowsie/Pure-JavaScript-HTML5-Parser/master/htmlparser.js" type="text/javascript"></script>
<script src="https://cdn.rawgit.com/blowsie/Pure-JavaScript-HTML5-Parser/master/src/html2json.js" type="text/javascript"></script>
<script>
import GetFooter from '@/components/footer.vue'
import router from '@/router'
import { db, auth } from '@/firebase'
import { svgs } from '@/svg.js'
var pdfMake = require('pdfmake/build/pdfmake.js')
var pdfFonts = require('pdfmake/build/vfs_fonts.js')
pdfMake.vfs = pdfFonts.pdfMake.vfs

pdfMake.fonts = {
	SFUIText: {
		normal: 'SFUIText-Regular.ttf',
		bold: 'SFUIText-Bold.ttf',
		italics: 'SFUIText-RegularItalic.ttf',
		bolditalics: 'SFUIText-BoldItalic.ttf'
	},
	Everett: {
		normal: 'Everett-Regular.otf',
		bold: 'Everett-Regular.otf',
		italics: 'Everett-Regular.otf',
		bolditalics: 'Everett-Regular.otf'
	}
}

export default {
	name: 'app',
	components: {
		GetFooter
	},
	data() {
		return {
			id: this.$route.params.id,
			isLoading: false,
			current_quote: [],
			versiones: [],
			current_version: ''
		}
	},
	firestore () {
		return {
			current_quote: db.collection('cotizaciones').doc(this.id),
			versiones: db.collection('cotizaciones').doc(this.id).collection('versiones').orderBy('folio', 'desc'),
		}
	},
	created() {
		var vm = this
		if(this.$route.params.id && this.$route.params.version){
			//Si existe id y version seleccionada
			db.collection('cotizaciones').doc(this.$route.params.id).collection('versiones').doc(this.$route.params.version)
			.get()
			.then(doc => {
				if (doc.exists) {
					//ajustar valores a version
					vm.current_version = doc.id
				} else {
					//sin informacion encontrada
					console.log("No such document!");
				}
			})
		}else if(this.$route.params.id && !this.$route.params.version){
			//Si existe el id de la cotizacion sin version selecionada
			db.collection('cotizaciones').doc(this.$route.params.id).collection('versiones').orderBy('folio', 'desc').limit(1)
			.get()
			.then(querySnapshot => {
				querySnapshot.forEach(function(doc) {
					//ajustar valores a version
					vm.current_version = doc.id
				})
			})
		}
	},
	methods: {
		viewVersion (id){
			this.current_version = id
			router.push({path: '/cotizacion/'+this.$route.params.id+'/'+id})
		},
		goTo (url){
			router.push({path: url})
		},
		deleteVersion (id){
			if(window.confirm('¿Estás Seguro? Esto eliminará esta versión')){
				db.collection('cotizaciones').doc(this.$route.params.id).collection('versiones').doc(id).delete().then(function() {
					console.log('Document successfully deleted!')
					router.push({path: '/cotizaciones/'})
				}).catch(function(error) {
					alert('Error de ejecución')
					console.error('Error removing document: ', error)
				})
			}
		},
		sum_inversion (version_sum){
			if(version_sum.propuesta_inversion && version_sum.propuesta_inversion.elementos){
				var total = 0
				for(var turn_element_sum = 0; turn_element_sum < version_sum.propuesta_inversion.elementos.length; turn_element_sum++){
					var element_sum_cantidad = this.$options.filters.formatEntero(version_sum.propuesta_inversion.elementos[turn_element_sum].cantidad)
					var element_sum_precio = this.$options.filters.formatDecimal(version_sum.propuesta_inversion.elementos[turn_element_sum].precio)
					if(element_sum_cantidad > 0 && element_sum_precio > 0){
						total += element_sum_cantidad * element_sum_precio
					}
				}
				return total
			}else{
				return 0
			}
		},
		convert_img_base64 (image){
			var path_image = require('../assets/' + image)

			return new Promise((resolve, reject) => {
				const img = new Image();
				img.setAttribute('crossOrigin', 'anonymous');
				img.onload = () => {
					const canvas = document.createElement("canvas");
					canvas.width = img.width;
					canvas.height = img.height;
					const ctx = canvas.getContext("2d");
					ctx.drawImage(img, 0, 0);
					const dataURL = canvas.toDataURL("image/png");
					resolve('data:image/png;base64,' + dataURL.replace('data:', '').replace(/^.+,/, ''))
				}
				img.onerror = reject
				img.src = path_image
			})
		},
		make_folio (select_version){
			var quote_folio = ''
			var version_folio = ''

			if(this.current_quote.folio){
				quote_folio = this.current_quote.folio
			}

			if(select_version.folio){
				version_folio = select_version.folio
			}

			if(quote_folio && version_folio){

				//Obtener secuencia_quote cotizaciones
				var secuencia_quote = ''

				if(quote_folio >= 0 && quote_folio < 10){
					secuencia_quote = '000'
				}else if(quote_folio >= 10 && quote_folio < 100){
					secuencia_quote = '00'
				}else if(quote_folio >= 100 && quote_folio < 1000){
					secuencia_quote = '0'
				}

				//Asignar folio
				return secuencia_quote + quote_folio + '_' + this.$options.filters.folioFormatDate(select_version.fecha.seconds) + '_v' + version_folio
			}else{
				return ''
			}
		},
		makeNewFolio (select_version){
			var desglose_servicios = ''
			var client_version = ''

			if(select_version.nombre){
				desglose_servicios = select_version.nombre
			}

			if(select_version.id_cliente){
				if(select_version.id_cliente.empresa){
					client_version += select_version.id_cliente.empresa + '_'
				}
				if(select_version.id_cliente.contacto){
					client_version += select_version.id_cliente.contacto
				}
			}

			return client_version + '_' + desglose_servicios
		}, 
		makeName (select_version, prefix_format){
			var client_version = ''
			var current_services = []
			var services_abbreviation = ''

			//Recorrer contenido productos version
			//if(select_version.contenido){
			//	for(var turn_current_service = 0; turn_current_service < select_version.contenido.length; turn_current_service++){
			//		//Revisar que el producto tenga un id de servicio
			//		if(select_version.contenido[turn_current_service].id_servicio){
			//			//Revisar que tenga el servicio una abreviacion
			//			if(select_version.contenido[turn_current_service].id_servicio.abreviacion){
			//				//Revisar que la abreviacion no haya sido incluida
			//				if(!current_services.includes(select_version.contenido[turn_current_service].id_servicio.abreviacion)){
			//					current_services += (select_version.contenido[turn_current_service].id_servicio.abreviacion).toUpperCase()
			//					services_abbreviation += (select_version.contenido[turn_current_service].id_servicio.abreviacion).toUpperCase() + '_'
			//				}
			//			}
			//		}
			//	}
			//}

			services_abbreviation = select_version.nombre

			if(select_version.id_cliente){
				if(select_version.id_cliente.empresa){
					client_version += select_version.id_cliente.empresa + '_'
				}
				if(select_version.id_cliente.contacto){
					client_version += select_version.id_cliente.contacto
				}
			}

			return prefix_format + this.make_folio(select_version) + '_' + 'Cotización' + '_' + client_version + '_' + services_abbreviation + '.pdf'
		}, 
		contruct_text (tag_type, before_tag, content_tag, children_tag, get_font_size){
			var result_text = []

			var font_size = 8 //Tamaño por default para texto en puntos
			var bold_state = false

			if(get_font_size > 0){
				font_size = get_font_size
			}

			var last_child = ''

			var inner_text_tag = []

			if(children_tag.length > 0){

				var init_text_second_level = content_tag

				for(const index in children_tag){

					var second_level = children_tag[index]

					//Variables que contienen el texto de la etiqueta y dividira la linea
					var divide_word_second_level = second_level['textContent']
					var before_init_text_second_level = init_text_second_level.substring(0, init_text_second_level.indexOf(divide_word_second_level))
					var after_init_text_second_level = init_text_second_level.substring(init_text_second_level.indexOf(divide_word_second_level) + divide_word_second_level.length)

					if(before_init_text_second_level != '' && before_init_text_second_level != ' '){
						inner_text_tag.push(before_init_text_second_level)
					}

					//Si se cuenta con el contenido de la etiqueta revisar que tipo de etiqueta es
					if(divide_word_second_level != '' && divide_word_second_level != ' '){

						//Asignar nuevo valor de tipografia
						if(second_level['tagName'] == 'SPAN'){
							if(second_level['attributes'][0][0] == 'style'){
								//Si se tiene el atributo estilo elimnar texto para obtener el tamaño multiplicandolo para obtener tamaño en puntos
								font_size = Math.floor(parseInt(second_level['attributes'][0][1].replace(/font-size:|px;/gi, '')) / 1) //1.33333
							}
						}

						//Obtener el texto formateado del interior de la etiqueta buscando hijos
						var tag_content = this.contruct_text(second_level['tagName'], before_init_text_second_level, second_level['textContent'], second_level['children'], font_size)

						if(second_level['tagName'] == 'LI'){
							inner_text_tag.push({text: tag_content, margin: [0,0,0,0], lineHeight: 1,})
						}else{
							inner_text_tag.push({text: tag_content})
						}

						if(second_level['tagName'] == 'SPAN'){
							//Si es una etiqueta span volver a colocar el tamaño de letra en default para evitar final de linea del mismo tamaño sin estar dentro de el span
							font_size = 0
						}

					}

					//Asignar nuevo valor al texto inicial
					init_text_second_level = after_init_text_second_level

				}

				//Revisar si al finalizar los hijos aun queda parte del texto que corresponderia al final de la linea
				if(after_init_text_second_level != '' && after_init_text_second_level != ' '){
					//Variable que contiene el texto resultado del interior de la linea (tag_type, before_tag, content_tag, children_tag, get_font_size)
					var content_last_text = this.contruct_text('NULL', '', after_init_text_second_level, [], font_size)
					if(content_last_text.length > 0){
						inner_text_tag.push({text: content_last_text})
					}
				}

			}else{
				//Si no tiene hijos el texto sera simple
				if(content_tag != '' && content_tag != ' '){
					if(tag_type == 'LI'){
						inner_text_tag.push({text: content_tag, margin: [0,0,0,0], lineHeight: 1,})
					}else if(tag_type == 'STRONG'){
						if(get_font_size > 0){
							inner_text_tag.push({text: content_tag, bold: true, fontSize: font_size})
						}else{
							inner_text_tag.push({text: content_tag, bold: true})
						}
					}else{
						if(get_font_size > 0){
							inner_text_tag.push({text: content_tag, fontSize: font_size})
						}else{
							inner_text_tag.push({text: content_tag})
						}
					}
				}
			}

			if(inner_text_tag.length > 0){
				result_text = inner_text_tag
			}

			return result_text
		},
		get_columns_to_pdf (contenedor_columnas){
			//Constante con las etiquetas html para el arreglo Json	data Elem = Elem Node
			const Elem = e => ({
				toJSON : () => ({
					tagName: 
						e.tagName,
					textContent:
						e.textContent,
					attributes:
						Array.from(e.attributes, ({name, value}) => [name, value]),
					children:
						Array.from(e.children, Elem)
				})
			})

			//html2json :: Node -> JSONString
			const html2json = e => JSON.stringify(Elem(e), null, '	')

			var columnas = contenedor_columnas['children']

			var count_turn_col = 1;

			var contenido_productos_cotizacion = []

			for(const index in columnas){

				var columna = columnas[index]

				//Solo si es un div para evitar el br que coloca que plugin columnize
				if(columna['tagName'] == 'DIV'){

					var siguiente_columna = columnas[parseInt(index) + 1] 

					var contenido_columna = columna['children']

					var counter_jumps = 0

					//Buscar en el contenido de cada columna
					for(const index in contenido_columna){

						var contenido_producto = contenido_columna[index]

						//Solo si es un div y tiene por lo menos 1 hijo para evitar columna vacia
						if(contenido_producto['tagName'] == 'DIV' && contenido_producto['children'].length > 0){

							for(var turn_children = 0; turn_children < contenido_producto['children'].length; turn_children++){

								var class_first_child = contenido_producto['children'][turn_children]['classList'][0]

								if(class_first_child == 'columnbreak'){
									counter_jumps++
								}
							}

							if(counter_jumps == 1){
								contenido_productos_cotizacion.push(
									{
										text: '', 
										pageBreak: 'after',
									},
								)
							}else{
								//HTML convertido a Json
								var html_to_json = html2json(contenido_producto)
								var result = this.html_to_pdf(html_to_json)

								if(result){
									contenido_productos_cotizacion.push(result)
								}
							}
						}

					}

				}

			}

			//console.log(cancelar_contenido)

			return contenido_productos_cotizacion
		},
		get_html_to_pdf (contenedor){
			//Constante con las etiquetas html para el arreglo Json	data Elem = Elem Node
			const Elem = e => ({
				toJSON : () => ({
					tagName: 
						e.tagName,
					textContent:
						e.textContent,
					attributes:
						Array.from(e.attributes, ({name, value}) => [name, value]),
					children:
						Array.from(e.children, Elem)
				})
			})

			//html2json :: Node -> JSONString
			const html2json = e => JSON.stringify(Elem(e), null, '	')

			//HTML convertido a Json
			var html_to_json = html2json(contenedor)

			var result = this.html_to_pdf(html_to_json)

			return result
		},
		html_to_pdf (JsonCode){
			var pdf_result = []

			if(JsonCode){
				var contenido = []
				var objeto_json = ''
				if(JsonCode.length){
					//Es el arreglo padre
					objeto_json = JSON.parse(JsonCode)
					contenido = objeto_json['children']
				}else{
					//Es un objeto hijo
					contenido = [JsonCode] //Convertir el objeto en un array
				}

				for(const index in contenido){
		
					var etiqueta_padre = contenido[index]
					var tipo_etiqueta = etiqueta_padre['tagName']
					var atributo = etiqueta_padre['attributes']
					var texto = etiqueta_padre['textContent']
					var hijos = etiqueta_padre['children']
					
					//Solo si se tiene un texto
					if(texto != '' && texto != ' '){
						var content_text = []
						var prev_text = texto

						//Construir texto (tag_type, before_tag, content_tag, children_tag, get_font_size)
						var line_content = this.contruct_text('NULL', '', texto, hijos, 'NULL', 0)

						//Etiqueta tipo p
						if(tipo_etiqueta == 'H1'){
							pdf_result.push({
								characterSpacing: -.2, 
								font: 'Everett',
								fontSize: 53, 
								lineHeight: 1,
								margin: [40, -10, 0, 30], //Margen izquierdo superior e inferior
								text: line_content,
							})
						}else if(tipo_etiqueta == 'H2'){
							pdf_result.push({
								bold: true, 
								margin: [0,0,0,15], //Margen inferior
								text: line_content,
								lineHeight: 1,
								fontSize: 13
							})
						}else if(tipo_etiqueta == 'P'){
							pdf_result.push({
								margin: [0,0,0,15], //Margen inferior
								lineHeight: 1,
								text: line_content
							})
						}else if(tipo_etiqueta == 'UL'){
							pdf_result.push({
								type: 'circle',
								ul: line_content,
								margin: [16,0,0,15] //Margen izquierdo e inferior
							})
						}else if(tipo_etiqueta == 'OL'){
							pdf_result.push({
								//separator: ' )',
								ol: line_content,
								margin: [16,0,0,15] //Margen izquierdo e inferior
							})
						}
					}
				}
			}
			return pdf_result
		},
		async makePdf (the_version, id_content, type_format){
			//Mostrar ventana de carga
			this.isLoading = true

			//Variable que contendra toda la cotizacion
			var the_content_quote = []

			//Variable con el año actual
			var current_year = new Date().getFullYear()

			//Variable con regex para reemplazar br
			var regex = /<br\s*[\/]?>/gi;

			/////////////////////////////////////////////////////////////////////
			/////////////////////////////////////////////////////////////////////
			///AGREGAR EL HTML DE PRODUCTOS Y NOTA DE INVERSION A SUS CONTENEDORES TEMPORALES
			/////////////////////////////////////////////////////////////////////
			/////////////////////////////////////////////////////////////////////

			//Colocar html de contenido productos en el contenedor temporal
			if($('#temporal_contenedor_productos').length && $('#'+id_content).find('.quote_page').length){
				$('#'+id_content).find('.quote_page').find('.quote_page_product').children().unwrap();
				if($('#'+id_content).find('.quote_page').html() != ''){
					//Si existe el contenedor añadir el html
					$('#temporal_contenedor_productos').html('')
					$('#temporal_contenedor_productos').uncolumnize()
					$('#temporal_contenedor_productos').html(($('#'+id_content).find('.quote_page').html()))

					//Solucion columnas con altura cercana
					var ancho_columna_temporal = 612 - 40 - 40 //Ancho pagina menos margenes horizontales
					var alto_columna_temporal = 792 - 125 - 60 //alto pagina menos margenes verticales

					$('#temporal_contenedor_productos').css({'width': ancho_columna_temporal + 'px'}) //Asignar ancho de una columna
					var altura_test = $('#temporal_contenedor_productos').outerHeight(true) //Obtener el alto del elemento con el nuevo ancho
					var total_cols = Math.ceil(altura_test / alto_columna_temporal) //Obtener el total de columnas dividiendo la altura entre el alto de la columna
					$('#temporal_contenedor_productos').css({'width': (ancho_columna_temporal * total_cols) + 'px'}) //Asignarle el nuevo ancho en base al total de las columnas
					$('#temporal_contenedor_productos').columnize({
						height : alto_columna_temporal, 
						width: ancho_columna_temporal,
						lastNeverTallest: true
					})
				}
			}

			//Colocar html de nota en el contenedor temporal
			if($('#temporal_contenedor_nota_propuesta_inversion').length && $('#'+id_content).find('.contenedor_nota_propuesta_inversion').length){
				if($('#'+id_content).find('.contenedor_nota_propuesta_inversion').html() != ''){
					//Si existe el contenedor añadir el html
					$('#temporal_contenedor_nota_propuesta_inversion').html('')
					$('#temporal_contenedor_nota_propuesta_inversion').html(($('#'+id_content).find('.contenedor_nota_propuesta_inversion').html()))
				}
			}

			//REMPLAZAR LOS BR CON SALTOS DE LINEA
			$('#temporal_contenedor_productos').html(($('#temporal_contenedor_productos').html()).replace(regex, "\n"))
			$('#temporal_contenedor_nota_propuesta_inversion').html(($('#temporal_contenedor_nota_propuesta_inversion').html()).replace(regex, "\n"))
			
			///////////////////////////////////////////
			///////////////////////////////////////////
			///INSERTAR PRIMERA PAGINA PORTADA
			///////////////////////////////////////////
			///////////////////////////////////////////
			
			the_content_quote.push(
				{
						svg: svgs.fondo_negro,
						width: 612,
						height: 792, 
						absolutePosition: {x: 0, y: 0}, 
				},
				{
					columns: [
						{
							width: 'auto',
							svg: svgs.logo_blanco,
							fit: [135, 28], 
							margin: [40, 0, 0, 0], //Margen izquierdo
						}, 
						{
							width: '*',
							text: [
								{text: 'Saturna Studio©\n', bold: true, characterSpacing: -.2,}, 
								{text: 'Información confidencial ' + current_year, characterSpacing: -.3,},
							], 
							margin: [0, 4, 0, 0], //Margen superior
							lineHeight: 1.2,
							style: {
								alignment: 'right', 
								color: 'white',
								fontSize: 9,
							},	
						}, 

					], 
					absolutePosition: {x: 0, y: 54},
				},
				{
					image: await this.convert_img_base64('adorno.png'),
					width: 426,
					height: 224, 
					absolutePosition: {x: 80, y: 150}, 
				}, 
				{
					svg: svgs.codigo_qr,
					width: 128,
					height: 128, 
					absolutePosition: {x: 522, y: 406}, 
				}, 
				{
					text: 'THE CREATIVE \n STUDIO WITH \n A GLOBAL VIEW',
					absolutePosition: {x: 160, y: 400}, 
					lineHeight: .85,
					style: {
						color: 'white',
						font: 'Everett',
						fontSize: 47,
						characterSpacing: -.5,
					},
				}, 
				{
					columns: [
						{
							width: 'auto',
							text: [
								{text: [
									{text: 'Saturna Studio ', bold: true,}, 
									{text: 'es un estudio creativo establecido en 2012 bajo la dirección creativa de diseñadores mexicanos Memo&Moi. \n',},
									{text: 'Desde entonces han evolucionado en su universo y a través del mundo con un equipo multidisciplinario y una red de aliados \n',},
									{text: 'estratégicos internacionales, clave de su visión global. El estudio se caracteriza por reflejar la simplicidad y atención al detalle por \n', characterSpacing: -.35,},
									{text: 'medio de formas, acabados y diseño sublime. La constante innovación forma parte de la esencia de todo lo que creamos. \n\n',},
								]}, 
								{text: [
									{text: 'Hoy no basta posicionarse solo como una marca sino más allá de la emoción. En Saturna estamos seguros de que tu marca tiene \n', characterSpacing: -.35,},
									{text: 'el poder de mover el mundo cuando establezca su universo. Hemos llevado marcas a lugares desconocidos a través del \n', characterSpacing: -.04,},
									{text: 'branding, nuestro sentido de navegación estratégico, expertise de tendencias y recursos atemporales. \n\n',},
								]}, 
								{text: [
									{text: 'Bienvenido. Estamos listos para crear tu universo.', bold: true,}, 
								]}, 
							], 
							lineHeight: 1,
							style: {
								alignment: 'justify', 
								color: 'white',
								fontSize: 8,
								characterSpacing: -.2,
							},
							margin: [40, 0, 0, 0], //Margen izquierdo
						},
					], 
					columnGap: 0,	
					absolutePosition: {x: 0, y: 566},
					pageBreak: 'after'
				}, 
			)

			///////////////////////////////////////////
			///////////////////////////////////////////
			///INSERTAR PAGINA INTRODUCCION
			///////////////////////////////////////////
			///////////////////////////////////////////
			
			if(the_version.id_cliente){
				if(the_version.id_cliente.nombre){
					var texto_nombre_cliente = 'Hola \n' + the_version.id_cliente.nombre
					var texto_servicios = ''

					var temp_services = []

					//Recorrer contenido productos version
					if(the_version.contenido){
						for(var turn_contenido = 0; turn_contenido < the_version.contenido.length; turn_contenido++){
							//Revisar que el producto tenga un id de servicio
							if(the_version.contenido[turn_contenido].id_servicio){
								//Revisar que tenga el servicio un nombre
								if(the_version.contenido[turn_contenido].id_servicio.nombre){
									//Revisar que el nombre no haya sido incluido
									if(!temp_services.includes(the_version.contenido[turn_contenido].id_servicio.nombre)){
										temp_services.push(the_version.contenido[turn_contenido].id_servicio.nombre)
									}
								}
							}
						}

						for(var turn_temp_service = 0; turn_temp_service < temp_services.length; turn_temp_service++){
							texto_servicios += temp_services[turn_temp_service]

							if(turn_temp_service < temp_services.length - 1){
								texto_servicios += ', '
							}
						}
					}

					var font_size_instroduccion = 55
					var total_caracteres_introduccion = texto_nombre_cliente.length + texto_servicios.length

					//Asignar tamaño letra a textos introduccion
					if(total_caracteres_introduccion <= 52){
						font_size_instroduccion = 55
					}else{
						font_size_instroduccion = parseInt(480 / (total_caracteres_introduccion / 4) * 1.85) //Dividir el ancho aproximado disponible entre el total de letras por linea y multiplicamos para obtener el tamaño de letra
					}

					//Asignar valores minimos y maximos en tamaño de texto para la introduccion
					if(font_size_instroduccion < 35){
						font_size_instroduccion = 35
					}else if(font_size_instroduccion > 55){
						font_size_instroduccion = 55
					}

					the_content_quote.push(
						{
							text: [
								{text: 'Cliente: ', bold: true},
								{text: the_version.id_cliente.empresa}, 
								{text: '\n'}, 
								{text: 'Contacto: ', bold: true},
								{text: the_version.id_cliente.contacto}, 
								{text: '\n'}, 
								{text: 'Fecha: ', bold: true},
								{text: this.$options.filters.singleFormatDate(the_version.fecha.seconds)}, 
							],
							style: {
								fontSize: 10,
							},
							margin: [40, 20, 0, 30], //Margen izquierdo superior e inferior
						},
						{
							text: [
								{text: texto_nombre_cliente, fontSize: font_size_instroduccion, lineHeight: .9}, 
							], 
							style: ['header_styles'], 
						},
						{
							canvas: [{ type: 'line', x1: 40, y1: 0, x2: 532, y2: 0, lineWidth: 1 }],
							margin: [0, 0, 0, 30], //Margen inferior
						}, 
						{
							text: [
								{text: 'Cotización en servicios integrales en: ',},
							],
							style: {
								fontSize: 10,
							},
							margin: [40, 0, 0, 20], //Margen izquierdo e inferior
						},
						{
							text: [
								{text: texto_servicios, fontSize: font_size_instroduccion, lineHeight: .8}, 
							], 
							style: ['header_styles'], 
						},
					)
				}
				the_content_quote.push(
					{
						columns: [
							{
								width: '100%',
								text: [
									{text: 'Nuestras Certificaciones Digitales:'}, 
								], 
								style: {
									fontSize: 13,
								},
							},

						], 
						absolutePosition: {x: 40, y: 615},
					},
				)
				the_content_quote.push(
					{
						columns: [
							{
								width: '100%',
								image: await this.convert_img_base64('logos-certificados.png'),
								fit: [480, 60], 
								alignment: 'center', 
							}, 

						], 
						absolutePosition: {x: 40, y: 648},
						pageBreak: 'after'
					}, 
				)
			}

			///////////////////////////////////////////
			///////////////////////////////////////////
			///INSERTAR PAGINA SERVICIOS
			///////////////////////////////////////////
			///////////////////////////////////////////
			
			if(the_version.contenido){
				//Incrustar contenido cotizacion
				var productos_cotizacion = this.get_columns_to_pdf(document.getElementById('temporal_contenedor_productos'))

				if(productos_cotizacion.length){
					the_content_quote.push(productos_cotizacion)
					the_content_quote.push(
						{
							text: '', 
							pageBreak: 'after',
						},
					)
				}
			}

			///////////////////////////////////////////
			///////////////////////////////////////////
			///INSERTAR PAGINA PROPUESTA ECONOMICA
			///////////////////////////////////////////
			///////////////////////////////////////////
			
			if(the_version.propuesta_inversion){
				//Agregar encabezado
				the_content_quote.push(
					{
						text: [
							{text: 'Propuesta \nEconómica'}, 
						], 
						style: ['header_styles'], 
					},
				)

				if(the_version.propuesta_inversion.elementos){
					var elementos_inversion = []

					elementos_inversion.push([
						{
							text: '',
							style: {
								bold: true
							},
							margin: [0, 0, 0, 10], //Margen inferior
						}, 
						{
							text: 'Frecuencia',
							style: {
								bold: true
							},
							margin: [20, 0, 0, 10], //Margen izquierdo e inferior
						}, 
						{
							text: 'Cantidad',
							style: {
								bold: true
							},
							alignment: 'right',
							margin: [20, 0, 0, 10], //Margen izquierdo e inferior
						}, 
						{
							text: 'Precio Unitario',
							style: {
								bold: true
							},
							alignment: 'right',
							margin: [20, 0, 0, 10], //Margen izquierdo e inferior
						}, 
						...(type_format == 'censurado' ? [{
							text: 'Horas Cotizadas',
							style: {
								bold: true
							},
							alignment: 'right',
							margin: [20, 0, 0, 10], //Margen izquierdo e inferior
						}] : []),
						{
							text: 'Subtotal',
							style: {
								bold: true
							},
							alignment: 'right',
							margin: [20, 0, 0, 10], //Margen izquierdo e inferior
						}
					])

					//Variable que contendra el total de la propuesta unico
					var total_inversion = 0.0

					for(var turno_elemento_inversion = 0; turno_elemento_inversion < the_version.propuesta_inversion.elementos.length; turno_elemento_inversion++){
						var elemento_inversion = the_version.propuesta_inversion.elementos[turno_elemento_inversion]

						if(elemento_inversion.nombre != '' && elemento_inversion.precio != ''){

							var elemento_inversion_precio = this.$options.filters.formatDecimal(elemento_inversion.precio)

							var elemento_inversion_subtotal = elemento_inversion.cantidad * elemento_inversion_precio

							var formato_elemento_inversion_precio = this.$options.filters.formatPrice(elemento_inversion_precio)

							var formato_elemento_inversion_total_horas = '---'

							var formato_elemento_inversion_subtotal = this.$options.filters.formatPrice(elemento_inversion_subtotal)  + ' MXP'

							if(type_format == 'censurado'){
							
								formato_elemento_inversion_precio = ''

								//Calcular las horas a trabajar
								if(elemento_inversion.precio != null && elemento_inversion.precio_hora != null){

									const precio_unitario = this.$options.filters.formatDecimal(elemento_inversion.precio);
									const precio_por_hora = this.$options.filters.formatDecimal(elemento_inversion.precio_hora);

									//No dividir si es igual o menor a 0
									if (precio_por_hora > 0) {
										formato_elemento_inversion_total_horas = Math.round(precio_unitario / precio_por_hora);
									}
								}

								formato_elemento_inversion_subtotal = ''
							
							}

							elementos_inversion.push([
								{
									text: elemento_inversion.nombre,
									margin: [0, 0, 0, 5], //Margen inferior
								}, 
								{
									text: elemento_inversion.frecuencia,
									margin: [20, 0, 0, 5], //Margen izquierdo e inferior
								}, 
								{
									text: elemento_inversion.cantidad,
									alignment: 'right',
									margin: [20, 0, 0, 5], //Margen izquierdo e inferior
								}, 
								{
									text: formato_elemento_inversion_precio,
									alignment: 'right',
									margin: [20, 0, 0, 5], //Margen izquierdo e inferior
								}, 
								...(type_format == 'censurado' ? [{
									text: formato_elemento_inversion_total_horas,
									alignment: 'right',
									margin: [20, 0, 0, 5],
								}] : []),
								{
									text: formato_elemento_inversion_subtotal,
									style: {
										bold: true
									},
									alignment: 'right',
									margin: [20, 0, 0, 5], //Margen izquierdo e inferior
								}
							])

							//Sumar al total unico
							total_inversion += elemento_inversion_subtotal
						}
					}

					var formato_total_inversion = this.$options.filters.formatPrice(total_inversion)  + ' MXP'

					if(type_format == 'censurado'){
							
						formato_total_inversion = ''
					
					}

					elementos_inversion.push([
						{
							text: '',
							style: {
								bold: true
							},
							margin: [0, 0, 0, 10], //Margen inferior
						}, 
						{
							text: '',
							style: {
								bold: true
							},
							margin: [20, 0, 0, 10], //Margen izquierdo e inferior
						}, 
						{
							text: '',
							style: {
								bold: true
							},
							alignment: 'right',
							margin: [20, 0, 0, 10], //Margen izquierdo e inferior
						}, 
						...(type_format == 'censurado' ? [{
							text: '',
							style: {
								bold: true
							},
							alignment: 'right',
							margin: [20, 0, 0, 10], //Margen izquierdo e inferior
						}] : []),
						{
							text: 'TOTAL',
							style: {
								bold: true
							},
							alignment: 'right',
							margin: [20, 0, 0, 10], //Margen izquierdo e inferior
						}, 
						{
							text: formato_total_inversion,
							style: {
								bold: true
							},
							alignment: 'right',
							margin: [20, 0, 0, 10], //Margen izquierdo e inferior
						}
					])

					//Agregar linea
					the_content_quote.push({
						canvas: [{ type: 'line', x1: 0, y1: 0, x2: 532, y2: 0, lineWidth: 1 }],
						margin: [0, 0, 0, 20], //Margen inferior
					})

					//Agregar tabla propuesta economica

					var anchos_tabla_inversion = ['*', 'auto', 60, 80, 100]

					if(type_format == 'censurado'){
						anchos_tabla_inversion = ['*', 'auto', 60, 80, 80, 100]
					}

					the_content_quote.push({
						table: {
							headerRows: 1,
							widths: anchos_tabla_inversion,
							body: elementos_inversion
						},
						layout: 'noBorders',
					})

					//Buscar si requiere salto de linea propuesta inversion
					if(the_version.propuesta_inversion.salto){
						//Agregar salto pagina
						the_content_quote.push(
							{
								text: '', 
								pageBreak: 'after',
							},
						)
						//Agregar encabezado
						the_content_quote.push(
							{
								text: [
									{text: 'Propuesta \nEconómica'}, 
								], 
								style: ['header_styles'], 
							},
						)
					}
				}

				//Buscar titulo propuesta inversion
				if(the_version.propuesta_inversion.titulo){
					var titulo_propuesta_inversion = {
						text: the_version.propuesta_inversion.titulo,
						style: {
							fontSize: 16,
							bold: true
						},
					}
				}

				//Buscar nota propuesta inversion
				if(the_version.propuesta_inversion.nota){
					var nota_propuesta_inversion = {
						text: this.get_html_to_pdf(document.getElementById('temporal_contenedor_nota_propuesta_inversion')),
						style: {
							characterSpacing: -.1,
							fontSize: 9,
						},
						margin: [0, 20, 0, 0], //Margen superior
					}
				}

				if(type_format == 'censurado'){
							
					titulo_propuesta_inversion = ' '
					nota_propuesta_inversion = ' '
				
				}

				//Si existe titulo o nota propuesta inversion agregarlas
				if(titulo_propuesta_inversion || nota_propuesta_inversion){
					the_content_quote.push(
						{
							table: {
								widths: ['*'],
								body: [
									[
										[
											titulo_propuesta_inversion,
											nota_propuesta_inversion, 
										]
									]
								]
							},
							layout: {
								hLineWidth: function (i, node) { return 0 },
								vLineWidth: function (i, node) { return 0 },
								hLineColor: function (i, node) { return null },
								vLineColor: function (i, node) { return null },
								hLineStyle: function (i, node) { return null },
								vLineStyle: function (i, node) { return null },
								paddingLeft: function(i, node) { return 25 },
								paddingRight: function(i, node) { return 25 },
								paddingTop: function(i, node) { return 25 },
								paddingBottom: function(i, node) { return 25 },
								fillColor: function (i, node) { return 'black' },
							},
							style: {
								color: 'white',
							},
							margin: [0, 30, 0, 20], //Margen superior e inferior
						}
					)
				}

				//Agregar procedimiento
				the_content_quote.push(
					{
						text: [
							{text: 'Procedimiento para iniciar el proyecto:', bold: true},
						], 
						style: {
							fontSize: 10,
						},
					},
					{
						text: '',
						margin: [0, 10, 0, 0], //Margen superior
					}, 
					{
						columns: [
							{
								width: 15,
								text: '1', 
								style: {
									bold: true,
									fontSize: 11,
								},
							},
							{
								width: '*',
								text: 'Firma de la cotización - autorización / firma de pagarés y pago correspondiente o anticipo / firma de contrato de confidencialidad y convenio de prestación de servicios.', 
							},
						], 
					}, 
					{
						text: '',
						margin: [0, 10, 0, 0], //Margen superior
					}, 
					{
						columns: [
							{
								width: 15,
								text: '2', 
								style: {
									bold: true,
									fontSize: 11,
								},
							},
							{
								width: '*',
								text: 'Cita para realizar el levantamiento de la información del proyecto.', 
							},
						], 
					}, 
					{
						text: '',
						margin: [0, 10, 0, 0], //Margen superior
					}, 
					{
						columns: [
							{
								width: 15,
								text: '3', 
								style: {
									bold: true,
									fontSize: 11,
								},
							},
							{
								width: '*',
								text: 'Posteriormente Saturna a través de la coordinación del proyecto realizará el plan de trabajo, el cual se le hará llegar al cliente con las fechas de avances y entregas. Es importante tomar en cuenta que a partir de la entrega de este cronograma es cuando se considera el tiempo aproximado del desarrollo del proyecto.', 
							},
						], 
					}, 
					{
						text: '',
						margin: [0, 15, 0, 0], //Margen superior
					}, 
					{
						text: [
							{text: 'RFC SCC190320Q64', bold: true},
							{text: '\n'}, 
							{text: 'STUDIO CREATIVO C3 SC', bold: true},
							{text: '\n\n'}, 
							{text: 'Institución Financiera: ',},
							{text: 'Citibanamex', bold: true},
							{text: '\n'}, 
							{text: 'Sucursal bancaria de apertura de la cuenta No. 301 / Av. López Mateos 161, Ladrón de Guevara, Guadalajara, Jal. México.',},
							{text: '\n'}, 
							{text: 'CUENTA DE CHEQUES MONEDA NACIONAL', bold: true},
							{text: '\n'}, 
							{text: 'CLABE INTERBANCARIA: 002320701444355819', bold: true},
							{text: '\n'}, 
							{text: 'SUCURSAL: 7014 NO. CUENTA 4435581', bold: true},
						], 
						style: {
							fontSize: 9,
						},
						pageBreak: 'after'
					},
				)
			}

			///////////////////////////////////////////
			///////////////////////////////////////////
			///INSERTAR PAGINA CONDICIONES
			///////////////////////////////////////////
			///////////////////////////////////////////
			the_content_quote.push(
				{
					text: [
						{text: 'Condiciones \ndel Servicio:'}, 
					], 
					style: ['header_styles'], 
				},
				{
					text: '',
					margin: [0, 5, 0, 0], //Margen superior
				}, 
				{
					text: [
						{text: '- A los precios establecidos en la propuesta, deberá de adicionárseles la tasa del Impuesto al Valor Agregado (IVA) de conformidad con la legislación fiscal aplicable.'}, 
						{text: '\n\n'}, 
						{text: '- Cualquier modificación o servicio que se requiera que no esté incluido en esta cotización tendrá un costo extra sin excepciones.'}, 
						{text: '\n\n'}, 
						{text: '- Los precios establecidos dentro de la cotización, tendrán una validez de 15 días.'}, 
						{text: '\n\n'}, 
						{text: '- Vigencia del Proyecto: el tiempo máximo de espera para que el cliente dé respuesta y seguimiento a su proyecto es de 7 días naturales, el cual comienza a contar en el momento que se solicite cualquier requerimiento. En caso de no tener respuesta por parte del cliente en este periodo, el proyecto pasará a un estatus de pausa y se reactivará con nuevos tiempos de entrega. Si el periodo de pausa excede un plazo de 90 días naturales, se dará por concluido el proyecto quedando el o los anticipos como penalización por incumplimiento por parte de El cliente.'}, 
						{text: '\n\n'}, 
						{text: '- Compromiso. Saturna Studio se compromete a entregar en tiempo y forma los avances o el total del desarrollo del proyecto, siempre y cuando no existan factores ajenos o de terceros, así como el tiempo que el cliente se tome para responder o autorizar los avances, que pudieran retrasar el proyecto, en caso de ser así se notificará el motivo así como una posible solución.'}, 
						{text: '\n\n'}, 
						{text: '- En caso de surgir cualquier tipo de improvisto, el Cliente y Saturna Studio, se comprometen a comunicarlo por correo electrónico y personalmente por teléfono o vídeo conferencia para acordar una solución a la posible situación.'}, 
						{text: '\n\n'}, 
						{text: '- Usuarios y contraseñas: los nombres de usuarios y/o contraseñas de redes sociales y/o correos electrónicos deben ser proporcionados y resguardados por el cliente. El cliente le dará acceso a Saturna Studio para poder realizar su gestión y operación. Saturna Studio no se hace responsable por los accesos que el cliente brinde a terceros por lo que recomendamos que durante la gestión y operación de Saturna Studio exista un sólo responsable por parte del cliente. En caso de que Saturna Studio genere los perfiles de redes sociales y/o correos electrónicos, le entregará al cliente esta información para que el cliente pueda resguardarla. Es importante que el cliente cambie las contraseñas al finalizar el contrato de prestación de servicios, debido a que posteriormente a Saturna Studio no se hará responsable de esto.'}, 
						{text: '\n\n'}, 
						{text: '- El tiempo del desarrollo del proyecto y/o fechas aproximadas de entrega comienzan a contar una vez cubiertos todos los requisitos antes mencionados así como contar con toda la información que se le solicite al cliente para la realización de su proyecto. En caso de que no se cubra alguno de estos requisitos será imposible comenzar con su proyecto sin excepciones.'}, 
						{text: '\n\n'}, 
						{text: '- Una vez entregado los archivos originales al cliente, Saturna Studio no se hace responsable de contar con una copia por si el cliente pierde sus archivos, por lo que sugerimos el cliente tome las medidas pertinentes para su resguardo.'}, 
						{text: '\n\n'}, 
						{text: '- En caso de pagos impuntuales por parte del cliente el servicio se suspenderá en la misma proporción de la demora del pago sin previo aviso y sin excepciones, además, y sin excepciones y se reiniciará el servicio con nuevas fechas de entrega hasta que el cliente realice el pago correspondiente.'}, 
						{text: '\n\n'}, 
						{text: '- En aquellos pagos realizados después de 15 días naturales de la emisión de la factura se cobrará un interés moratorio del 5% mensual.'}, 
						{text: '\n\n'}, 
						{text: 'CANCELACIONES: Una vez iniciado el proyecto, la cancelación de éste por parte del cliente causará la pérdida total del o los anticipos más un 30% del valor total de proyecto como pena convencional.'}, 
					], 
					style: {
						alignment: 'justify', 
						characterSpacing: .4,
						fontSize: 8,
					},
					pageBreak: 'after'
				}, 
			)

			///////////////////////////////////////////
			///////////////////////////////////////////
			///INSERTAR PAGINA CLIENTES
			///////////////////////////////////////////
			///////////////////////////////////////////
			the_content_quote.push(
				{
					text: [
						{text: 'Brands \n& Projects'}, 
					], 
					style: ['header_styles'], 
				},
				{
					text: [
						{text: 'Hoy no basta posicionarse solo como una marca sino más allá de la emoción. En Saturna estamos seguros de que tu marca tiene el poder de mover el mundo cuando establezca su universo. Hemos llevado marcas a lugares desconocidos a través del branding, nuestro sentido de navegación estratégico, expertise de tendencias y recursos atemporales.'},
						{text: '\n\n'}, 
						{text: 'Aquí las marcas destacadas que han confiado en nuestro trabajo.'}, 
					], 
					style: {
						alignment: 'justify', 
						fontSize: 11,
					},
				}, 
				{
					image: await this.convert_img_base64('logos-clientes.png'),
					fit: [480, 300], 
					alignment: 'center', 
					margin: [0, 40, 0, 0], //Margen superior
					pageBreak: 'after'
				},
			)

			///////////////////////////////////////////
			///////////////////////////////////////////
			///INSERTAR PAGINA FINAL CONTRAPORTADA
			///////////////////////////////////////////
			///////////////////////////////////////////
			the_content_quote.push({
				svg: svgs.simbolo_negro,
				fit: [175, 175], 
				absolutePosition: {x: 218, y: 308},
			})

			///////////////////////////////////////////
			///////////////////////////////////////////
			///CONFIGURACION PDF
			///////////////////////////////////////////
			///////////////////////////////////////////

			var config_pdf = {
				compress: true, //Comprimir calidad
				pageSize: {
					width: 612, //Tamaño de hoja en puntos
					height: 792
				},
				pageOrientation: 'portrait', //Orientacion hoja
				pageMargins: [ 40, 125, 40, 80 ], //Margenes en puntos (izquierda, superior, derecha inferior)

				header: function(currentPage, pageCount) { 
					if(currentPage != 1){
						return [
							{
								columns: [
									{
										width: 'auto',
										svg: svgs.recuadro_simbolo,
										fit: [52, 52], 
										margin: [40, 40, 0, 0], //Margen izquierdo y superior
									},
									{
										width: 'auto',
										text: [
												{text: 'Contact\n\n', bold: true,}, 
												{text: 'hello@saturnastudio.com\n',},
												{text: 'T. +52 (33) 23 05 88 17\n',},
												{text: 'www.saturnastudio.com',},
										], 
										margin: [27, 40, 0, 0], //Margen izquierdo y superior
										lineHeight: 1,
										style: {
											characterSpacing: -.3,
											fontSize: 9,
										},
									},
									{
										width: 'auto',
										text: [
												{text: 'Studio\n\n', bold: true,}, 
												{text: 'Av. Lopez Mateos Sur 2180 - E\n',},
												{text: 'Cuidad del Sol / CP 45050\n',},
												{text: 'Zapopan, México.',},
										], 
										margin: [27, 40, 0, 0], //Margen izquierdo y superior
										lineHeight: 1,
										style: {
											characterSpacing: -.3,
											fontSize: 9,
										},
									},
									{
										width: 'auto',
										text: [
												{text: 'Social\n\n', bold: true,}, 
												{text: 'Facebook / Instagram / Behance\n',},
												{text: '@bysaturna\n',},
												{text: 'saturnastudio.com',},
										], 
										margin: [27, 40, 0, 0], //Margen izquierdo y superior
										lineHeight: 1,
										style: {
											characterSpacing: -.3,
											fontSize: 9,
										},
									},
								],
							},
						]
					}
				},

				footer: function(currentPage, pageCount) { 
					if(currentPage != 1){
						return [
							{
								columns: [
									{
										width: 'auto',
										svg: svgs.logo_negro,
										fit: [135, 28], 
										margin: [40, 8, 0, 0], //Margen izquierdo
									}, 
									{
										width: '*',
										text: [
											{text: 'Saturna Studio©\n', bold: true, characterSpacing: -.2,}, 
											{text: 'Información confidencial ' + current_year, characterSpacing: -.3,},
										], 
										margin: [0, 15, 40, 0], //Margen superior y derecho
										lineHeight: 1.2,
										style: {
											alignment: 'right', 
											fontSize: 9,
										},	
									}, 

								]
							}
						]
					}else{
						return [
							{
								columns: [
									{
										width: 'auto',
										svg: svgs.simbolo_blanco,
										fit: [48, 48], 
										margin: [40, 0, 0, 0], //Margen izquierdo
									}, 
									{
										width: '*',
										text: [
											{text: 'saturnastudio.com', bold: true, characterSpacing: -.2,},
										], 
										margin: [0, 18, 40, 0], //Margen superior y derecho
										lineHeight: 1,
										style: {
											alignment: 'right', 
											color: 'white',
											fontSize: 9,
										},	
									}, 
								], 								
							},
						]
					}
				},

				content: the_content_quote,
				pageBreakBefore: function(currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) {
					return currentNode.headlineLevel === 1 && followingNodesOnPage.length === 0;	
				},
				styles: {
					header_styles: {
						characterSpacing: -.3, 
						font: 'Everett',
						fontSize: 58, 
						lineHeight: .8,
						margin: [40, -10, 0, 30], //Margen izquierdo superior e inferior
					},
				},
				defaultStyle: {
					font: 'SFUIText', //Tipografia por default
					columnGap: 0, //Eliminar por dafault el medianil de columnas
					color: '#000000', //Color por default para texto
					fontSize: 8 //Tamaño por default para texto en puntos
				}
			}
			
			///////////////////////////////////////////
			///////////////////////////////////////////
			///CREAR PDF
			///////////////////////////////////////////
			///////////////////////////////////////////

			var prefix_format = ''

			if(type_format == 'censurado'){

				prefix_format = 'a_trabajar_'
			
			}
			
			pdfMake.createPdf(config_pdf).download(this.makeName(the_version, prefix_format))
			
			var vm = this
			setTimeout(function function_name() {
				vm.isLoading = false
			}, 1000)

			///////////////////////////////////////////
			///////////////////////////////////////////
			///RESTAURAR VALORES
			///////////////////////////////////////////
			///////////////////////////////////////////

			//RESTAURAR LOS BR 
			$('#temporal_contenedor_productos').html(($('#temporal_contenedor_productos').html()).replace(/\n/g, "<br />"))
			$('#temporal_contenedor_nota_propuesta_inversion').html(($('#temporal_contenedor_nota_propuesta_inversion').html()).replace(/\n/g, "<br />"))
		}
	},
}
</script>
<style src='vue-swatches/dist/vue-swatches.min.css'></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>